import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojaislamertourpackage() {



    const cardData = {

keyword: "Pune to Jaisalmer Tour Package",

headingDescription:
    "Rising Cab Service offers a safe, comfortable, and well-planned Pune to Jaisalmer Tour Package for families, friends, and luxury desert travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, Mini Bus, and Luxury Urbania vehicles with experienced chauffeurs for long-distance Rajasthan journeys. With doorstep pickup from Pune, customized sightseeing itineraries, flexible one-way and round-trip options, 24/7 support, and transparent pricing, we ensure a smooth and memorable desert travel experience to the Golden City of Jaisalmer.",

topPlaces: [
    {
        title: "Jaisalmer Fort (Sonar Quila)",
        description:
            "Jaisalmer Fort, also known as Sonar Quila or the Golden Fort, is one of the largest living forts in the world and a UNESCO World Heritage Site. Built from golden-yellow sandstone, it glows beautifully under sunlight and houses homes, temples, shops, and palaces within its walls. Visitors experience a unique blend of history, architecture, and living culture as people still reside inside the fort, making it one of the most extraordinary heritage sites in India."
    },
    {
        title: "Sam Sand Dunes",
        description:
            "Sam Sand Dunes is the most famous desert area near Jaisalmer, known for its vast golden Thar Desert landscapes and thrilling experiences like camel safaris and jeep safaris. Tourists enjoy stunning sunset views, cultural folk performances, and traditional Rajasthani hospitality. It is one of the best places to experience the true desert lifestyle and adventure activities in Rajasthan."
    },
    {
        title: "Patwon Ki Haveli",
        description:
            "Patwon Ki Haveli is a cluster of five grand havelis known for its intricate carvings, detailed architecture, and historical importance. It showcases the rich lifestyle of wealthy traders of Jaisalmer and reflects the artistic excellence of Rajasthan. Each section of the haveli is filled with beautiful artwork, balconies, and antique designs."
    },
    {
        title: "Gadisar Lake",
        description:
            "Gadisar Lake is a peaceful artificial lake surrounded by temples, ghats, and artistic archways. It was once the main water source for Jaisalmer and is now a popular tourist attraction for boating and photography. During sunrise and sunset, the lake offers stunning reflections of temples and birds, creating a calm and scenic atmosphere."
    },
    {
        title: "Kuldhara Village",
        description:
            "Kuldhara is an abandoned village near Jaisalmer known for its mysterious history and legends. Once inhabited by the Paliwal Brahmins, the village was suddenly deserted centuries ago. Today, it stands as a haunting yet fascinating heritage site attracting tourists interested in mystery, history, and photography."
    },
    {
        title: "Desert National Park",
        description:
            "Desert National Park is one of the largest national parks in India, showcasing the unique ecosystem of the Thar Desert. It is home to rare wildlife species like the Great Indian Bustard, desert foxes, and reptiles. The park offers an amazing experience of desert biodiversity and natural conservation."
    },
    {
        title: "Bada Bagh",
        description:
            "Bada Bagh is a historic garden complex known for its royal cenotaphs (chhatris) of Jaisalmer rulers. Located on a hilltop, it offers panoramic views of the desert and sunset scenery. The golden sandstone cenotaphs create a magical visual experience, especially during evening hours."
    },
    {
        title: "Khuri Sand Dunes",
        description:
            "Khuri Sand Dunes are a quieter alternative to Sam Sand Dunes, offering a more peaceful desert experience. Visitors enjoy camel rides, cultural programs, and traditional village stays, making it ideal for travelers seeking less crowded and more authentic desert life."
    },
    {
        title: "Jain Temples of Jaisalmer Fort",
        description:
            "The Jain Temples inside Jaisalmer Fort are beautifully carved ancient temples dedicated to various Jain Tirthankaras. Known for their intricate sandstone architecture and spiritual significance, these temples are an important cultural and religious highlight inside the fort complex."
    },
    {
        title: "Thar Desert Scenic Drive",
        description:
            "The journey from Pune to Jaisalmer includes long scenic highway routes passing through Maharashtra, Gujarat, and Rajasthan. The desert landscapes, open highways, and cultural stops make the journey itself a memorable part of the tour package experience."
    }
],



services: [
{
name: "Jaisalmer Desert Tour Package from Pune",
description: "Rising Cab Service offers Jaisalmer Desert Tour Package from Pune for a complete Rajasthan travel experience covering golden sand dunes, desert safari, forts, and cultural attractions. Enjoy comfortable AC vehicles, professional chauffeurs, doorstep pickup from Pune, and flexible itineraries designed for families, couples, and groups seeking a memorable desert holiday."
},
{
name: "Jaisalmer Tour Package for Family",
description: "Book Jaisalmer Tour Package for Family with safe and comfortable travel options from Pune. Our package includes well-maintained cars, experienced drivers, and planned sightseeing to ensure a smooth and enjoyable family vacation in the desert city of Jaisalmer."
},
{
name: "Pune to Jaisalmer Tour Package",
description: "Our Pune to Jaisalmer Tour Package is designed for long-distance leisure travel with complete comfort and reliability. Explore Jaisalmer Fort, Sam Sand Dunes, and local attractions with AC vehicles, flexible stops, and professional chauffeur service."
},
{
name: "Jaisalmer Tour Package from Pune",
description: "Rising Cab Service provides Jaisalmer Tour Package from Pune with customized travel plans, luxury and budget options, and safe long-distance cab service ideal for families and groups exploring Rajasthan."
},
{
name: "Pune to Jaisalmer Desert Tour Package",
description: "Book Pune to Jaisalmer Desert Tour Package for an unforgettable journey into the Thar Desert. Enjoy desert safari, camel rides, cultural shows, and comfortable travel with experienced drivers and premium vehicles."
},
{
name: "Pune to Jaisalmer Holiday Package",
description: "Our Pune to Jaisalmer Holiday Package offers a perfect mix of sightseeing, relaxation, and desert adventure. Travel in comfort with AC cars, flexible itineraries, and complete travel assistance for a stress-free vacation."
},
{
name: "Pune to Jaisalmer 3 Nights 4 Days Package",
description: "Rising Cab Service provides Pune to Jaisalmer 3 Nights 4 Days Package for a well-planned short vacation covering major attractions, desert safari experiences, and comfortable long-distance travel from Pune."
},
{
name: "Pune to Jaisalmer 5 Days Tour Package",
description: "Book Pune to Jaisalmer 5 Days Tour Package for a detailed exploration of Rajasthan’s desert city. Enjoy extended sightseeing, cultural experiences, and premium cab service for a relaxed journey."
},
{
name: "Pune to Jaisalmer Family Tour Package",
description: "Our Pune to Jaisalmer Family Tour Package ensures safe and comfortable travel for families with spacious vehicles, experienced drivers, and customized travel planning for a memorable holiday."
},
{
name: "Pune to Jaisalmer Couple Tour Package",
description: "Rising Cab Service offers Pune to Jaisalmer Couple Tour Package for romantic desert getaways with private cab service, comfortable stays, and personalized travel experience."
},
{
name: "Pune to Jaisalmer Group Tour Package",
description: "Book Pune to Jaisalmer Group Tour Package for large group travel with Tempo Traveller or Urbania options, ensuring comfort, safety, and coordinated sightseeing across Jaisalmer."
},
{
name: "Pune to Jaisalmer Desert Safari Package",
description: "Our Pune to Jaisalmer Desert Safari Package includes thrilling dune rides, camel safari, cultural performances, and comfortable travel arrangements for a complete desert adventure experience."
},
{
name: "Pune to Jaisalmer Sightseeing Package",
description: "Rising Cab Service provides Pune to Jaisalmer Sightseeing Package covering forts, havelis, markets, and desert attractions with flexible travel and experienced drivers."
},
{
name: "Pune to Jaisalmer Luxury Tour Package",
description: "Book Pune to Jaisalmer Luxury Tour Package for premium travel experience with high-end vehicles, comfortable seating, and personalized itinerary for a luxury Rajasthan trip."
},
{
name: "Pune to Jaisalmer Budget Tour Package",
description: "Our Pune to Jaisalmer Budget Tour Package offers affordable travel options without compromising comfort, including safe cab service and planned sightseeing."
},
{
name: "Pune to Jaisalmer Cab Service",
description: "Rising Cab Service provides Pune to Jaisalmer Cab Service for long-distance travel with clean vehicles, professional drivers, and 24x7 booking support."
},
{
name: "Pune to Jaisalmer Taxi Service",
description: "Book Pune to Jaisalmer Taxi Service for safe, reliable, and comfortable intercity travel with transparent pricing and experienced chauffeurs."
},
{
name: "Pune to Jaisalmer One Way Cab",
description: "Our Pune to Jaisalmer One Way Cab service is ideal for drop-only travel with affordable pricing, AC vehicles, and professional drivers for long-distance journeys."
},
{
name: "Pune to Jaisalmer Round Trip Taxi",
description: "Rising Cab Service offers Pune to Jaisalmer Round Trip Taxi with flexible return schedules, comfortable travel, and safe driving for long journeys."
},
{
name: "Pune to Jaisalmer Car Rental",
description: "Book Pune to Jaisalmer Car Rental for private travel with flexible stops, AC comfort, and experienced chauffeur-driven service."
},
{
name: "Pune to Jaisalmer Outstation Cab",
description: "Our Pune to Jaisalmer Outstation Cab ensures safe and reliable long-distance travel with well-maintained vehicles and professional drivers."
},
{
name: "Pune to Jaisalmer Innova Crysta Cab",
description: "Rising Cab Service provides Pune to Jaisalmer Innova Crysta Cab for premium comfort, spacious seating, and smooth highway travel for families and groups."
},
{
name: "Pune to Jaisalmer 7 Seater Cab",
description: "Book Pune to Jaisalmer 7 Seater Cab for small family trips with comfortable seating, AC interiors, and safe long-distance travel experience."
},
{
name: "Best Cab Service Pune to Jaisalmer",
description: "Our Best Cab Service Pune to Jaisalmer ensures top-quality vehicles, experienced drivers, and reliable support for a smooth and comfortable Rajasthan journey."
}
],

tableData: [
["Jaisalmer Desert Tour Package from Pune","Jaisalmer Tour Package for Family"],
["Pune to Jaisalmer Tour Package","Jaisalmer Tour Package from Pune"],
["Pune to Jaisalmer Desert Tour Package","Pune to Jaisalmer Holiday Package"],
["Pune to Jaisalmer 3 Nights 4 Days Package","Pune to Jaisalmer 5 Days Tour Package"],
["Pune to Jaisalmer Family Tour Package","Pune to Jaisalmer Couple Tour Package"],
["Pune to Jaisalmer Group Tour Package","Pune to Jaisalmer Desert Safari Package"],
["Pune to Jaisalmer Sightseeing Package","Pune to Jaisalmer Luxury Tour Package"],
["Pune to Jaisalmer Budget Tour Package","Pune to Jaisalmer Cab Service"],
["Pune to Jaisalmer Taxi Service","Pune to Jaisalmer One Way Cab"],
["Pune to Jaisalmer Round Trip Taxi","Pune to Jaisalmer Innova Crysta Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Jaisalmer Tour Package",
        WhyChoosedescription: "Rising Cab Service provides premium Pune to Jaisalmer tour packages for families, tourists, couples, corporate groups, and Rajasthan holiday travelers."
    },
    {
        WhyChooseheading: "Explore the Golden City of Rajasthan",
        WhyChoosedescription: "Jaisalmer is famous for its magnificent forts, royal palaces, desert landscapes, cultural heritage, camel safaris, and traditional Rajasthani hospitality."
    },
    {
        WhyChooseheading: "Customized Rajasthan Tour Packages",
        WhyChoosedescription: "Choose from family vacations, honeymoon packages, group tours, cultural trips, desert adventures, and customized Rajasthan travel itineraries."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Travel",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Urbania, and Mini Buses according to your group size and travel preferences."
    },
    {
        WhyChooseheading: "Visit Major Attractions in Jaisalmer",
        WhyChoosedescription: "Explore Jaisalmer Fort, Patwon Ki Haveli, Gadisar Lake, Nathmal Ki Haveli, Bada Bagh, Sam Sand Dunes, and Kuldhara Village."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Tours",
        WhyChoosedescription: "Our professional drivers ensure safe highway travel, smooth long-distance journeys, and a comfortable travel experience throughout the Rajasthan tour."
    },
    {
        WhyChooseheading: "Perfect for Family Holidays and Group Tours",
        WhyChoosedescription: "Our Jaisalmer tour packages are ideal for family vacations, honeymoon trips, educational tours, corporate outings, and Rajasthan sightseeing holidays."
    }
]
};

const faqData = [
    {
        question: "Why is Jaisalmer called the Golden City?",
        answer: "Jaisalmer is known as the Golden City because of its magnificent yellow sandstone architecture, forts, palaces, and historic buildings."
    },
    {
        question: "Which attractions are covered in the Jaisalmer tour package?",
        answer: "Popular attractions include Jaisalmer Fort, Patwon Ki Haveli, Gadisar Lake, Sam Sand Dunes, Bada Bagh, Nathmal Ki Haveli, and Kuldhara Village."
    },
    {
        question: "Can Sam Sand Dunes and desert safari be included in the package?",
        answer: "Yes, customized packages can include camel safari, jeep safari, cultural programs, desert camping, and evening entertainment."
    },
    {
        question: "Which vehicle is suitable for a family Rajasthan tour?",
        answer: "Ertiga and Innova Crysta are ideal for families, while Tempo Travellers and Urbania are recommended for larger groups."
    },
    {
        question: "Can Jodhpur and Jaisalmer be covered in one trip?",
        answer: "Yes, customized Rajasthan packages can include Jaisalmer, Jodhpur, Jaipur, Udaipur, Mount Abu, and other destinations."
    },
    {
        question: "Are Tempo Travellers available for group tours?",
        answer: "Yes, Tempo Travellers, Urbania, and Mini Buses can be arranged for family groups, corporate tours, and educational trips."
    },
    {
        question: "Can hotel accommodations be included in the package?",
        answer: "Yes, customized packages can include hotel bookings, sightseeing arrangements, and complete tour planning."
    },
    {
        question: "Is Jaisalmer suitable for honeymoon trips?",
        answer: "Yes, Jaisalmer is one of Rajasthan's most popular destinations for couples because of its royal heritage, desert camps, and scenic landscapes."
    },
    {
        question: "What is the best time to visit Jaisalmer?",
        answer: "The ideal time to visit Jaisalmer is from October to March when the weather is pleasant for sightseeing and desert activities."
    },
    {
        question: "How can I book a Pune to Jaisalmer Tour Package?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rajesh Patil",
        feedback:
            "Our Rajasthan vacation was unforgettable. The Jaisalmer tour was perfectly organized, the vehicle was comfortable, and we enjoyed every sightseeing destination along the journey.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neha Kulkarni",
        feedback:
            "The desert safari, fort visits, and cultural experiences in Jaisalmer were amazing. Rising Cab Service managed the travel arrangements professionally and made our family holiday truly memorable.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Jaisalmer Tour Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-jaisalmer-tour.jpg",
"description": "Book Pune to Jaisalmer Tour Package with Rising Cab Service for a memorable Rajasthan desert holiday. Ideal for family, couple, and group tours including desert safari, camel rides, and sightseeing in Jaisalmer.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Custom Package",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-jaisalmer-tour-package"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Jaisalmer Tour Package | Desert Safari Holiday | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Jaisalmer Tour Package for a memorable Rajasthan desert holiday. Enjoy desert safari, camel rides, and sightseeing for family, couple, and group tours."
/>

<meta
 name="keywords"
 content="jaisalmer desert tour package from pune, pune to jaisalmer tour package, jaisalmer tour package from pune, pune to jaisalmer desert tour, pune to jaisalmer holiday package, 3 nights 4 days jaisalmer package pune, 5 days jaisalmer tour pune, jaisalmer family tour pune, jaisalmer couple tour pune, jaisalmer group tour pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojaislamertourpackage;